import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const links = [
  ['INÍCIO', 'inicio'], ['SOBRE A FESTA', 'sobre'], ['LOCALIZAÇÃO', 'localizacao'],
  ['LISTA DE PRESENTES', 'presentes'], ['GALERIA', 'galeria'], ['AVISOS', 'avisos'], ['CADERNO DE RECADOS', 'caderno'],
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const go = (id: string) => {
    if (id === 'galeria') { navigate('/galeria'); setOpen(false); return; }
    if (id === 'caderno') { navigate('/caderno-de-recados'); setOpen(false); return; }
    if (id === 'avisos') { navigate('/avisos'); setOpen(false); return; }
    if (id === 'presentes') { navigate('/lista-de-presentes'); setOpen(false); return; }
    if (id === 'sobre') { navigate('/sobre-a-festa'); setOpen(false); return; }
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }); setOpen(false);
  };
  return (
    <header className="ys-navbar">
      <button className="ys-monogram" onClick={() => go('inicio')} aria-label="Início"><img src="/assets/monograma-ysl.png" alt="Yasmin Siqueira" /></button>
      <nav className={open ? 'ys-navlinks open' : 'ys-navlinks'} aria-label="Navegação principal">
        {links.map(([label,id]) => <button key={id} onClick={() => go(id)}>{label}</button>)}
      </nav>
      <button className="ys-menu" onClick={() => setOpen(!open)} aria-label="Abrir menu"><i className={open ? 'ri-close-line' : 'ri-menu-line'} /></button>
    </header>
  );
}
